module.exports = __webpack_public_path__ + "static/bg-main-2-a74a2ba172df45f6590e86fbbbc80f11.jpg";